import React from "react";
import { toLower } from "lodash";
import { Table } from "../../components/AntdTable";
import { Content } from "../../components/Layout";
import { Box, Flex } from "../../components/Flex";
import { Label, Title } from "../../components/Text";
import { Button } from "../../components/Button";
import { CloseIcon } from "../../icons/CloseIcon";
import { RemoveIcon } from "../../icons/RemoveIcon";
import { formatDate } from "../../utils";
import { VerifiedIcon } from "../../icons/VerifiedIcon";
import { UntestedIcon } from "../../icons/UntestedIcon";
import { ColumnTitle } from "../../components/ColumnTitle";

const ContractsDetails = ({ title, data, loading, renderFieldContent, activateContract, deleteContract, onClose }) => {

    const columns = [
        {
            title: ({ sortOrder, sortColumn }) => ColumnTitle(sortOrder, sortColumn, "orgName", "Name"),
            dataIndex: 'orgName',
            sorter: (a, b) => { if (a && a.hasOwnProperty("orgName") && a.orgName) return a.orgName.localeCompare(b.orgName) }
        },
        {
            title: ({ sortOrder, sortColumn }) => ColumnTitle(sortOrder, sortColumn, "endDate", "Expiry"),
            dataIndex: "endDate",
            width: 150,
            defaultSortOrder: "descend",
            render: (text, record, index) => <>{formatDate(text, "DD-MMM-YYYY")}</>,
            sorter: (a, b) => { if (a && a.hasOwnProperty("endDate") && a.endDate) return a.endDate.localeCompare(b.endDate) },
        },
        {
            dataIndex: "remove",
            width: 50,
            render: (text, record, index) => (
                <RemoveIcon
                    small
                    color="var(--sp-label-color)"
                    hoverColor="var(--sp-paragraph-color)"
                    onClick={() => deleteContract({ alias: record.orgAlias, contract: data.name, org: record.orgName, key: data.key })}
                />
            )
        }
    ];

    const fields = [
        { label: "Description", attr: "description" },
        { label: "Registered by", attr: "registeredBy" },
        { label: "Updated by", attr: "updatedBy" }
    ];

    return(
        <Content gap={{ bottom: 21 }}>
            <Flex width="100%" justify="space-between" margin={{ bottom: "24px"}}>
                <Flex align="center" gap={{ right: 8 }}>
                    {data.active ? <VerifiedIcon /> : <UntestedIcon />}
                    <Title h4 isLoading={loading}>
                        {title}
                    </Title>
                </Flex>
                <CloseIcon onClick={onClose} />
            </Flex>
            <Flex height="calc(100% - 114px)" gap={{ right: 32 }}>
                <Box flex={1} gap={{ bottom: 17 }}>
                    <Flex justify="space-between" align="center">
                        <Title h4 capitalize>about contract</Title>
                        {/* <ActionText onClick={() => showForm("organisations", data)}>
                            <span><EditDetailsIcon /></span>
                            <span>Edit Info</span>
                        </ActionText> */}
                    </Flex>
                    <Flex direction="column" gap={{ bottom: 20 }}>
                        {renderFieldContent(fields, data)}
                    </Flex>
                </Box>
                <Box flex={1} gap={{ bottom: 17 }}>
                    <Flex align="center">
                        <Title h4 capitalize>Assigned to</Title>
                    </Flex>
                    <div style={{ height: "calc(100% - 45px)" }}>
                        <Table
                            columns={columns}
                            dataSource={data && data.hasOwnProperty("orgs") ? data.orgs : []}
                            pagination={false}
                            rowKey="orgAlias"
                            scroll={{ y: true }}
                            showSorterTooltip={false}
                            locale={{ emptyText: <Label size="18px" bold color="#D7E3F7">not assigned to any organisation</Label> }}
                            loading={loading}
                        />
                    </div>
                </Box>
            </Flex>
            <Flex justify="space-between">
                <Button
                    type={data.active ? "danger" : "primary" }
                    disabled={data.active === undefined || loading || (data.active && data.orgs && data.orgs.length)}
                    onClick={() => activateContract({ contract: toLower(data.name), activeFlag: !data.active })}
                >
                    {data.active ? "Deactivate" : "Activate"}
                </Button>
                <Button onClick={onClose}>Close</Button>
            </Flex>
        </Content>
    );
};

export { ContractsDetails }